import { render, staticRenderFns } from "./EditProjectManage.vue?vue&type=template&id=5b5903b7&"
import script from "./EditProjectManage.vue?vue&type=script&lang=js&"
export * from "./EditProjectManage.vue?vue&type=script&lang=js&"
import style0 from "./EditProjectManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports